/**
 * useTelegramAuth - Hook for Telegram OAuth flow
 *
 * Read-only build: social linking has no backend. `initiateAuth` is an inert
 * no-op; `isAuthenticating` / `error` are still exported so pages that
 * destructure them keep working unchanged.
 */

import { useCallback, useState } from 'react';

/**
 * @param {Object} options - Configuration options
 * @returns {Object} - { isAuthenticating, error, initiateAuth }
 */
export const useTelegramAuth = (options = {}) => {
  const [isAuthenticating] = useState(false);
  const [error] = useState(null);

  const initiateAuth = useCallback(async () => {
    console.warn('[useTelegramAuth] Linking Telegram is disabled on the read-only site.');
    return;
  }, []);

  return {
    isAuthenticating,
    error,
    initiateAuth,
  };
};

export default useTelegramAuth;
